"use client";

import React, { useEffect } from "react";
// import { useGetTermsAndConditions } from "@/hooks/ApiHooks/termsAndConditionsHook/getTermsAndConditionsHook";

export default function TermsAndConditions() {
  // const { data: termsAndConditionsData } = useGetTermsAndConditions();

  useEffect(() => {
      // Update page title
      document.title = "Terms & Conditions | Gemini UAE";
      
      // Update meta description
      let descriptionMeta = document.querySelector('meta[name="description"]');
      if (!descriptionMeta) {
        descriptionMeta = document.createElement('meta');
        descriptionMeta.setAttribute('name', 'description');
        document.head.appendChild(descriptionMeta);
      }
      descriptionMeta.setAttribute('content', "Read the terms and conditions outlining usage, policies, and guidelines to ensure a secure and transparent experience with Gemini UAE.");
  
      // Update canonical URL
      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.setAttribute('rel', 'canonical');
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.setAttribute('href', "https://geminiuae.com/terms-and-conditions");
      
    },[]);

  return (
    <div>
      <div className="max-w-[90.69vw] sm:max-w-[90.80vw] lg:max-w-[89.58vw] mx-auto">
        <h2
          className="text-mob-38 sm:text-tab-38 lg:text-web-50 leading-mob-55 sm:leading-tab-55 lg:leading-[120%]
               text-SecondaryYellow tracking-wider font-normal lg:font-normal capitalize drop-shadow-sm text-center
               py-mob-46 sm:py-tab-40 lg:py-web-50 rounded-lg
               bg-[url('/images/header-text-wrapper-mob.webp')] sm:bg-[url('/images/header-text-wrapper.webp')]
               bg-cover bg-center"
        >
          Terms & Conditions
        </h2>
      </div>

      <div className="max-w-[90.69vw] sm:max-w-[90.80vw] lg:max-w-[65.58vw] mx-auto py-mob-80 sm:py-tab-90 lg:py-[5.72vw]">
        <ul>
          <li className="mb-mob-38 sm:mb-tab-38 lg:mb-web-58">
            <h6 className="text-mob-18 sm:text-tab-18 lg:text-web-26 leading-[120%] font-medium text-TitleBlack capitalize mb-mob-20 sm:mb-tab-20 lg:mb-web-25">
              1. Terms
            </h6>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              By accessing the website at http://geminiuae.com, you are agreeing
              to be bound by these terms of service, all applicable laws and
              regulations, and agree that you are responsible for compliance
              with any applicable local laws. If you do not agree with any of
              these terms, you are prohibited from using or accessing this site.
              The materials contained in this website are protected by
              applicable copyright and trademark law.
            </p>
          </li>
          <li className="mb-mob-38 sm:mb-tab-38 lg:mb-web-58">
            <h6 className="text-mob-18 sm:text-tab-18 lg:text-web-26 leading-[120%] font-medium text-TitleBlack capitalize mb-mob-20 sm:mb-tab-20 lg:mb-web-25">
              2. Use License
            </h6>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              Permission is granted to temporarily download one copy of the
              materials (information or software) on GBM’s website for personal,
              non-commercial transitory viewing only. This is the grant of a
              license, not a transfer of title, and under this license you may
              not:
            </p>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              Modify or copy the materials;
            </p>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              Use the materials for any commercial purpose, or for any public
              display (commercial or non-commercial);
            </p>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              Attempt to decompile or reverse engineer any software contained on
              GBM’s website;
            </p>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              Remove any copyright or other proprietary notations from the
              materials; or
            </p>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              Transfer the materials to another person or “mirror” the materials
              on any other server.
            </p>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              This license shall automatically terminate if you violate any of
              these restrictions and may be terminated by GBM at any time. Upon
              terminating your viewing of these materials or upon the
              termination of this license, you must destroy any downloaded
              materials in your possession whether in electronic or printed
              format.
            </p>
          </li>
          <li className="mb-mob-38 sm:mb-tab-38 lg:mb-web-58">
            <h6 className="text-mob-18 sm:text-tab-18 lg:text-web-26 leading-[120%] font-medium text-TitleBlack capitalize mb-mob-20 sm:mb-tab-20 lg:mb-web-25">
              3. Disclaimer
            </h6>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              The materials on GBM’s website are provided on an ‘as is’ basis.
              GBM makes no warranties, expressed or implied, and hereby
              disclaims and negates all other warranties including, without
              limitation, implied warranties or conditions of merchantability,
              fitness for a particular purpose, or non-infringement of
              intellectual property or other violation of rights.
            </p>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              Further, GBM does not warrant or make any representations
              concerning the accuracy, likely results, or reliability of the use
              of the materials on its website or otherwise relating to such
              materials or on any sites linked to this site.
            </p>
          </li>
          <li className="mb-mob-38 sm:mb-tab-38 lg:mb-web-58">
            <h6 className="text-mob-18 sm:text-tab-18 lg:text-web-26 leading-[120%] font-medium text-TitleBlack capitalize mb-mob-20 sm:mb-tab-20 lg:mb-web-25">
              4. Limitations
            </h6>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              In no event shall GBM or its suppliers be liable for any damages
              (including, without limitation, damages for loss of data or
              profit, or due to business interruption) arising out of the use or
              inability to use the materials on GBM’s website, even if GBM or a
              GBM authorized representative has been notified orally or in
              writing of the possibility of such damage. Because some
              jurisdictions do not allow limitations on implied warranties, or
              limitations of liability for consequential or incidental damages,
              these limitations may not apply to you.
            </p>
          </li>
          <li className="mb-mob-38 sm:mb-tab-38 lg:mb-web-58">
            <h6 className="text-mob-18 sm:text-tab-18 lg:text-web-26 leading-[120%] font-medium text-TitleBlack capitalize mb-mob-20 sm:mb-tab-20 lg:mb-web-25">
              5. Accuracy of materials
            </h6>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              The materials appearing on GBM website could include technical,
              typographical, or photographic errors. GBM does not warrant that
              any of the materials on its website are accurate, complete or
              current. GBM may make changes to the materials contained on its
              website at any time without notice. However GBM does not make any
              commitment to update the materials.
            </p>
          </li>
          <li className="mb-mob-38 sm:mb-tab-38 lg:mb-web-58">
            <h6 className="text-mob-18 sm:text-tab-18 lg:text-web-26 leading-[120%] font-medium text-TitleBlack capitalize mb-mob-20 sm:mb-tab-20 lg:mb-web-25">
              6. Links
            </h6>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              GBM has not reviewed all of the sites linked to its website and is
              not responsible for the contents of any such linked site. The
              inclusion of any link does not imply endorsement by GBM of the
              site. Use of any such linked website is at the user’s own risk.
            </p>
          </li>
          <li className="mb-mob-38 sm:mb-tab-38 lg:mb-web-58">
            <h6 className="text-mob-18 sm:text-tab-18 lg:text-web-26 leading-[120%] font-medium text-TitleBlack capitalize mb-mob-20 sm:mb-tab-20 lg:mb-web-25">
              7. Modifications
            </h6>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              GBM may revise these terms of service for its website at any time
              without notice. By using this website you are agreeing to be bound
              by the then current version of these terms of service.
            </p>
          </li>
          <li className="mb-mob-38 sm:mb-tab-38 lg:mb-web-58">
            <h6 className="text-mob-18 sm:text-tab-18 lg:text-web-26 leading-[120%] font-medium text-TitleBlack capitalize mb-mob-20 sm:mb-tab-20 lg:mb-web-25">
              8. Governing Law
            </h6>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              These terms and conditions are governed by and construed in
              accordance with the laws of UAE and you irrevocably submit to the
              exclusive jurisdiction of the courts in that State or location.
            </p>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              As a building material specialist, Gemini Building Materials
              maintains a broad base of activities advising clients on building
              materials issues. An indication of our services includes: supply,
              advice, design, planning and execution of our services.
            </p>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              The distributor from A to Z building materials is ready to meet
              with any requirements. We are ready to offer all the services
              required when dealing with any requests. Together we will find a
              solution of any issue and we are equipped perfect to offer you an
              optimal full house experience, expertise and responsibility under
              one roof.
            </p>
          </li>
        </ul>
      </div>
      {/* <div className="max-w-[90.69vw] sm:max-w-[90.80vw] lg:max-w-[65.58vw] mx-auto py-mob-80 sm:py-tab-90 lg:py-[5.72vw]"
        dangerouslySetInnerHTML={{ __html: termsAndConditionsData ? termsAndConditionsData.content.rendered : "Loading..." }}
      /> */}
    </div>
  );
}
